export default __webpack_public_path__ + "static/media/yellow.e700be53.svg";